
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shops",
      function () {
        return require("private-next-pages/shops.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shops"])
      });
    }
  